import { postCreate, patchNew, deleteNew, getAllNews as fetchAllNews } from "../../../service/ServiceNews";

export const newsService = {
  getAllNews: async () => {
    return fetchAllNews();
  },

  createNews: async (payload) => {
    return postCreate(payload);
  },

  updateNews: async (id, payload) => {
    return patchNew({ ...payload, id });
  },

  deleteNews: async (id, id_img) => {
    return deleteNew(id, id_img);
  },
};

export default newsService;